export const NAV_HEIGHT = 53;
export const SIDE_PADDING = 20;
export const TOP_PADDING = 8;
export const BOTTOM_PADDING = 16;
export const PLAYER_HEIGHT = 120;
export const PADDING_AFTER_PAGE = 8;

export const SELECTION_PADDING_FRACTION = 0.1;
export const HIGHLIGHT_PADDING_FRACTION = SELECTION_PADDING_FRACTION + 0.1;
